//
// Product Link Validator
//
// ---------------------------------------------------------------------------

'use strict';

const config = {
    targetClass: '.js-body-product-link',
    ajaxUrl: '/docs/php/product/getProducts',
    noStyleClass: 'no-style'
};

class ProductLinkValidator {

    constructor() {
        this.validate();
    }

    validate() {
        const productLinks = $(config.targetClass);
        const productsUrl = $(config.targetClass).data('url');

        if(productLinks.length === 0 || !productsUrl) {
            return;
        }

        let inputIds = {};
        productLinks.each(function () {
            const stockNumber = $(this).text().replace(/[()\-]/g, '');
            inputIds[stockNumber] = inputIds[stockNumber] || [];
            inputIds[stockNumber].push($(this));
        });

        if(inputIds.length === 0) {
            return;
        }

        ProductLinkValidator.loadProducts(Object.keys(inputIds), productsUrl).always(products => {
            if(!Array.isArray(products)) {
                products = [];
            }

            let outputIds = [];
            products.forEach(product => {
                outputIds.push(String(product.stockNumber))
            });

            // if product is available, enable styles on the link
            for (let [key, val] of Object.entries(inputIds)) {
                if(outputIds.includes(String(key))) {
                    val.forEach((element) => {
                        const parent = element.parent();
                        parent.find('a').removeClass(config.noStyleClass);
                    });
                }
            }
        });
    }

    static loadProducts(productIds, productsUrl) {
        let ids = [];
        for(let i = 0 ; i < productIds.length ; i++) {
            ids.push(productIds[i]);
        }

        return $.ajax({
            url: productsUrl,
            data: {'id':ids},
            dataType: 'json'
        });
    }
}

$(window).ready(function(){
    new ProductLinkValidator();
});



// WEBPACK FOOTER //
// ./src/js/components/product-link-validator.js